import { make } from 'vuex-pathify'
import dottie from 'dottie'
import { api } from '@/api'

const state = {
  validVoucher: null
}

const getters = {
  ...make.getters(state)
}

const mutations = {
  read(state, { validVoucher }) {
    state.validVoucher = validVoucher
    state.readOK = true
  },

  readFailed(state) {
    state.validVoucher = null
    state.readOK = false
  }
}

const actions = {
  async redeemVoucherCode({ commit }, { rewardId, voucherCode, buyerId }) {
    try {
      const response = await api.post('/vouchers/redeem', {
        rewardId,
        voucherCode,
        buyerId
      })
      const valid = dottie.get(response, 'data.valid', false)
      if (valid) {
        commit('read', {
          validVoucher: {
            rewardId,
            voucherCode,
            buyerId
          }
        })
      }
    } catch (e) {
      commit('readFailed')
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
